import React from "react";
import classes from './ExplorerReviews.module.css';
import StarRating from "../../components/ui/ratingStar";
import GoogleBadge from "../../components/ui/GoogleBadge";

const ExplorerReviews = (props) => {

    const reviewData = props.reviewData;
    const dummyUserImg = "https://imgs.search.brave.com/7Iaf-hcRBvKKBcvqVJRkiKqmN01soThV0d4-HDfBsL8/rs:fit:860:0:0/g:ce/aHR0cHM6Ly90NC5m/dGNkbi5uZXQvanBn/LzA2Lzg2LzQ0LzEx/LzM2MF9GXzY4NjQ0/MTE5N19LaWNublVX/M0N4bDE1eUdPRUhS/TUJ2S2V1THliQ1Y4/VS5qcGc"

    return (
        <div className={classes['review-container']}>
            {
                reviewData.map(review => {
                    return (
                        <div className={classes['review-card']}>
                            <div className="flex flex-row items-end">
                                <img className={classes['semicolon-img']} src="https://static.wixstatic.com/media/da937f_4465ba2382404b23852f8a39ac8c79ea~mv2.png/v1/crop/x_241,y_242,w_111,h_97/fill/w_42,h_36,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/Exploro%20Logic%20(12).png" alt="" />
                                <GoogleBadge className="ml-auto lg:w-[2.5vw] lg:h-[2.5vw] w-[5vw] h-[5vw] mr-[3vw] lg:mr-0" />
                            </div>

                            <p className={classes['review-trip-name']}>{review.reviewTrip}</p>
                            <p className={classes['review-trip-month']}>{review.reviewTripMonth}</p>
                            <p className={classes['review-trip-rating']}>{<StarRating rating={(review.reviewTitle[0] * 1) || 4.5} />}</p>
                            <p className={classes['review-trip-review']}>{review.reviewContent}</p>

                            <div className={classes['review-card-bottom-container']}>
                                {/* <img className={classes['review-card-img']} src={review.reviewExplorerPic || dummyUserImg} alt="" /> */}
                                <svg
                                    width="505px"
                                    height="40px"
                                    viewBox="0 0 75 100"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    className={classes['review-card-img']}
                                >
                                    <circle cx="35" cy="30" r="15" fill="transparent" strokeWidth="5px" stroke="#949494" />
                                    <path stroke="#949494" strokeWidth="5px" d={"M 0 93 A 10 10 0 0 1 70 93 L 70 93 L 0 93 Z"}
                                        fill="transparent" />
                                    {/* "M 0 ${height} A ${rx} ${ry} 0 0 1 ${width} ${height} L ${width} ${height} L 0 ${height} Z"  */}
                                </svg>
                                <p className={classes['review-card-reviewer']}>{review.reviewExplorer}</p>
                            </div>

                        </div>
                    )
                })
            }
        </div>
    )
};


export default ExplorerReviews;